import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/settings/organizationMine';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation() {
  try {
    const res = yield call(
      axios.get,
      `${config.API_URL}/organization/mine`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(res?.data?.data ?? res?.data ?? {}));
  } catch (error) {
    // Pure rail-gating lookup — failures just hide the Organization item,
    // so no global error / snackbar here.
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
